import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loadingStates: [],
  selectedRecord: null,
  parentCompanies: [],
  passwordPolicies: [],
  ldapServers: [],
  emailServers: [],
  success: false
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'companyRecords'] }
}

const fetchCompanySuccess = (state, action) => {
  let { records, pagination } = action
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'companyRecords'),
    pagination: pagination,
    records: records
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'companyRecords')
  }
}

const fetchCompanyByIdSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(
      item => !['saveCompany', 'companyRecords'].includes(item)
    ),
    selectedRecord: action.recordData
  }
}

const clearSelectedCompanyRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'saveCompany'] }
}

const createCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveCompany'),
    success: true
  }
}

const createCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveCompany'),
    success: false
  }
}

const updateCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'saveCompany'] }
}

const updateCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveCompany'),
    success: true
  }
}

const updateCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveCompany'),
    success: false
  }
}

const deleteCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'saveCompany'] }
}

const deleteCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveCompany'),
    success: true
  }
}

const deleteCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveCompany'),
    success: false
  }
}

const fetchParentCompanyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'parent_id'] }
}

const fetchParentCompanySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'parent_id'),
    parentCompanies: action.data
  }
}

const fetchParentCompanyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'parent_id'),
    message: action.errorMessage
  }
}

const fetchPasswordPolicyStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'password_policy_id'] }
}

const fetchPasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'password_policy_id'),
    passwordPolicies: action.data
  }
}

const fetchPasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'password_policy_id'),
    message: action.errorMessage
  }
}

const fetchLdapServerStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'ldap_server_id'] }
}

const fetchLdapServerSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'ldap_server_id'),
    ldapServers: action.data
  }
}

const fetchLdapServerFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'ldap_server_id'),
    message: action.errorMessage
  }
}

const fetchEmailServerStart = (state, action) => {
  return { ...state, loadingStates: [...state.loadingStates, 'email_server_id'] }
}

const fetchEmailServerSuccess = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'email_server_id'),
    emailServers: action.data
  }
}

const fetchEmailServerFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'email_server_id'),
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_BY_ID_SUCCESS:
      return fetchCompanyByIdSuccess(state, action)
    case actionTypes.FETCH_COMPANY_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.CLEAR_SELECTED_COMPANY_RECORD:
      return clearSelectedCompanyRecord(state, action)
    case actionTypes.CREATE_COMPANY_START:
      return createCompanyStart(state, action)
    case actionTypes.CREATE_COMPANY_SUCCESS:
      return createCompanySuccess(state, action)
    case actionTypes.CREATE_COMPANY_FAILED:
      return createCompanyFailed(state, action)
    case actionTypes.UPDATE_COMPANY_START:
      return updateCompanyStart(state, action)
    case actionTypes.UPDATE_COMPANY_SUCCESS:
      return updateCompanySuccess(state, action)
    case actionTypes.UPDATE_COMPANY_FAILED:
      return updateCompanyFailed(state, action)
    case actionTypes.DELETE_COMPANY_START:
      return deleteCompanyStart(state, action)
    case actionTypes.DELETE_COMPANY_SUCCESS:
      return deleteCompanySuccess(state, action)
    case actionTypes.DELETE_COMPANY_FAILED:
      return deleteCompanyFailed(state, action)
    case actionTypes.FETCH_PARENT_COMPANY_OPTIONS_START:
      return fetchParentCompanyStart(state, action)
    case actionTypes.FETCH_PARENT_COMPANY_OPTIONS_SUCCESS:
      return fetchParentCompanySuccess(state, action)
    case actionTypes.FETCH_PARENT_COMPANY_OPTIONS_FAILED:
      return fetchParentCompanyFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START:
      return fetchPasswordPolicyStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS:
      return fetchPasswordPolicySuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED:
      return fetchPasswordPolicyFailed(state, action)
    case actionTypes.FETCH_LDAP_SERVER_OPTIONS_START:
      return fetchLdapServerStart(state, action)
    case actionTypes.FETCH_LDAP_SERVER_OPTIONS_SUCCESS:
      return fetchLdapServerSuccess(state, action)
    case actionTypes.FETCH_LDAP_SERVER_OPTIONS_FAILED:
      return fetchLdapServerFailed(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_OPTIONS_START:
      return fetchEmailServerStart(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_OPTIONS_SUCCESS:
      return fetchEmailServerSuccess(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_OPTIONS_FAILED:
      return fetchEmailServerFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
